<template>
  <div class="wrapper" v-if="data != undefined">
    <Menu />

    <div class="modal-area d-flex align-items-center justify-content-center" v-if="confirmation">
      <div class="modal-box align-self-center text-center">
        <h1 class="fs-16 fc-2 mb-2">
          Bu kampanyaya katılarak
          <span class="fc-6 font-weight-bold">200 PUAN</span>
          harcayacaksın emin misiniz?
        </h1>
        <button class="confirm-button" @click="confirmCampaign();">Evet Eminim</button>
        <button class="ignore-button" @click="confirmationToggle();">Vazgeç</button>
      </div>
    </div>

    <div class="modal-area d-flex align-items-center justify-content-center" v-if="locationInfo">
      <div class="modal-box align-self-center">
        <h1 class="fs-16 fc-2 mb-2">Kampanyaya katılabilmek için konum izni vermen gerekmektedir.</h1>
        <button class="confirm-button">Ayarlar</button>
        <button class="ignore-button" @click="toggleLocationInfo();">Kapat</button>
      </div>
    </div>
    <Header hideMore title="Anadolu Efes Fan Club Kampanyaları" />
    <div class="body-area pt70">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <img :src="data.image" class="w-100" />
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20">{{data.name}}</h1>
              </div>
              <div class="box-body">
                <p v-html="data.description"></p>

                <DownloadApp />

                <div class="best-offer no-gutters row" v-if="1==0">
                  <div class="col-1">
                    <img src="/static/demoimages/32.jpg" class="w-100 rounded-circle blue-border" />
                  </div>
                  <div class="col-9 pl-2">
                    <h1 class="fs-10 fc-1">
                      EN YÜKSEK TEKLİF
                      <br />
                      <span class="fc-6">520 PUAN</span> İLE OZAN Ç.
                    </h1>
                  </div>
                </div>
              </div>

              <div class="action-timer no-gutters row" v-if="1==0">
                <div class="col-6">
                  <h3>Açık artırma kampanyasının sonlanmasına kalan süre:</h3>
                </div>
                <div class="col-6 text-right">
                  <span class="timer">16:55</span>
                </div>
              </div>
              <div class="auction-actions no-gutters row d-flex align-items-center" v-if="1==0">
                <div class="col-6 p-0">
                  <h1 class="fc-1 fs-20">500 Puan</h1>
                </div>
                <div class="col-6 p-0">
                  <button class="confirm-button" @click="toggleLocationInfo();">Katıl</button>
                </div>
              </div>

              <div class="auction-actions no-gutters row d-flex align-items-center" v-if="1==0">
                <div class="col-12 p-0">
                  <button
                    class="confirm-button"
                    type="button"
                    @click="confirmationToggle();"
                  >Kampanyaya Katıl</button>
                </div>
              </div>
            </div>

            <div class="campain-rules">
              <p v-html="data.legal_text"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import DownloadApp from "@/components/DownloadApp";
import axios from "axios";
export default {
  name: "FanClubDetail",
  components: {
    Footer,
    Menu,
    Header,
    DownloadApp
  },
  data() {
    return {
      locationInfo: false,
      confirmation: false,
      data: this.$route.params.data
    };
  },
  methods: {
    confirmationToggle() {
      this.confirmation = !this.confirmation;
    },
    toggleLocationInfo() {
      this.locationInfo = !this.locationInfo;
    },
    confirmCampaign() {
      this.$router.push({ name: "FanClubSuccess" });
    }
  },
  created() {
    if (this.data == undefined) {
      this.$store.state.loading = true;

      axios.post("kampanya/liste").then(res => {
        this.data = res.data.data.find(k => k.id == this.$route.params.slug);
        this.$store.state.loading = false;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/FanClubDetail.vue